import { compose } from 'redux';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';

import withToday from 'common/containers/withToday';
import { getDays } from 'data/selectors';
import { withAuth } from 'modules/auth';

import { default as Component } from '../components/ForecastList';

export default compose(
    withAuth,
    withToday,
    firestoreConnect(({ auth: { user }, startOfMonth, endOfMonth }) => {
        return [
            {
                collection: 'transactions',
                where: [
                    ['ownerId', '==', user.uid],
                    ['date', '>=', startOfMonth],
                    ['date', '<=', endOfMonth],
                ],
                orderBy: ['date'],
                storeAs: `transactions/${startOfMonth.getTime()}`
            },
            {
                collection: 'budget',
                doc: user.uid,
                storeAs: 'budget'
            },
            {
                collection: 'bigExpenses',
                where: [
                    ['ownerId', '==', user.uid],
                    ['startDate', '>=', startOfMonth],
                    ['startDate', '<=', endOfMonth]
                ],
                storeAs: `bigExpenses/${startOfMonth.getTime()}`
            }
        ];
    }),
    connect((state) => {
        return {
            days: getDays(state)
        };
    })
)(Component);